// extracted by css-extract-rspack-plugin
export default {"form":"yZayNISBw81nmGun","user_name":"OFYKcgI53Nopq36e","table":"YaZdhH28MC8gRX2v"};